import ReactDOM from 'react-dom'
import * as selectors from './datetime.selector'
import Datetime from './Datetime'
import { constants } from './datetime.constant'

const SelectComponent = (() => {
	const renderDatetime = (renderTarget: HTMLElement, inputTarget: HTMLElement, locale: string) => {
		if (renderTarget.parentElement === null) {
			return
		}

		ReactDOM.render(
			ReactDOM.createPortal(
				<Datetime inputTarget={inputTarget} locale={locale}></Datetime>,
				renderTarget.parentElement,
			),
			renderTarget,
		)
	}

	const initSelects = () => {
		const targets = selectors.getTargets()

		if (targets.length === 0) {
			return
		}

		targets.forEach((el) => {
			renderDatetime(el, el, el.getAttribute(constants.selector.locale) ?? 'cs')
		})
	}

	const init = () => {
		initSelects()
	}

	return {
		init,
	}
})()

export default SelectComponent
